import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Button as BootstrapButton } from "react-bootstrap";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Toast } from "primereact/toast";
import { ConfirmDialog } from "primereact/confirmdialog";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";

import {
    SERVICE_LOCATION, GET_MEASURESCOUNT_BY_SITE, GET_INVOICING_MEASURES_FOR_SITE, RETURN_ACCOUNTS_TO_BRANCH, PROCESS_PAY_APP, APPROVE_FINANCE,
    DOWNLOAD_WORKCARD_DETAILS_BY_MEASUREIDs, DOWNLOAD_PENDING_INVOICE_WORKCARD_DETAILS_BY_SYSTEMID, GET_TAX_CODES
} from "../constants/endpoints";

import { INVOICE_RETURN_REASONS } from "../constants/newBuildConstants";
import { SELECT_RETURN_REASON } from "../constants/errors";

import "./../assets/styles/table.css";
import "./../assets/styles/worksheets.css";
import "./../assets/styles/dialog.css";

const PendingInvoices = (props) => {
    const toast = useRef(null);

    const { data } = props;
    const userName = (data !== undefined && data !== null) ? data.data.userDetails.userName : "";
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";

    const [loading, setLoading] = useState(false);
    const [showPdfViewer, setShowPdfViewer] = useState(false);
    const [showProcessPayAppDialog, setShowProcessPayAppDialog] = useState(false);
    const [sitesData, setSitesData] = useState(null);
    const [taxCodes, setTaxCodes] = useState(null);
    const [taxRate, setTaxRate] = useState(0);
    const [selectedTaxCode, setSelectedTaxCode] = useState(null);
    const [selectedSite, setSelectedSite] = useState(null);
    const [showMeasures, setShowMeasures] = useState(false);
    const [measuresData, setMeasuresData] = useState(null);
    const [returnMeasures, setReturnMeasures] = useState(null);
    const [dialogHeader, setDialogHeader] = useState("");
    const [pdfUrl, setPdfUrl] = useState("");
    const [disabaleReturnToBranchButton, setDisabaleReturnToBranchButton] = useState(true);
    const [confirmationDialogMessage, setConfirmationDialogMessage] = useState("");
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [showNoProcessedInvoicesDialog, setShowNoProcessedInvoicesDialog] = useState(false);
    const [selectedAction, setSelectedAction] = useState("");
    const [siteDataPage, setSiteDataPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [showReturnDialog, setShowReturnDialog] = useState(false);
    const [selectedReturnReason, setSelectedReturnReason] = useState(null);
    const [returnReasonComments, setReturnReasonComments] = useState("");
    const [returnReasonError, setReturnReasonError] = useState(false);

    useEffect(() => {
        getSitesData();
        getTaxCodes();
        initFilters();
    }, [])

    const getSitesData = () => {
        setLoading(true);
        const endPoint = SERVICE_LOCATION + GET_MEASURESCOUNT_BY_SITE;
        axios.get(endPoint, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            if (response.data.isSuccess) {
                const res = response.data.data.measuresCountBySite;
                var filteredByDepot = userDepot === "NONE" ? res : res.filter((item) => item.depotName === userDepot);
                setSitesData(filteredByDepot);
                if (filteredByDepot === 0) {
                    setShowMeasures(false);
                }
            }
            else if (!response.data.isSuccess) {
                setSitesData(null);
                setShowMeasures(false);
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const getTaxCodes = () => {
        setLoading(true);
        const endPoint = SERVICE_LOCATION + GET_TAX_CODES;
        axios.get(endPoint, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                const resTaxCodes = response.data.data.taxCodes
                setSelectedTaxCode(resTaxCodes[0]);
                setTaxCodes(resTaxCodes);
            }
            else if (!response.data.isSuccess) {
                setTaxCodes(null);
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const getMeasuresData = (systemId) => {
        setLoading(true);
        const endPoint = SERVICE_LOCATION + GET_INVOICING_MEASURES_FOR_SITE;
        const requestedData = {
            systemId: systemId
        }
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            if (response.data.isSuccess) {
                setMeasuresData(response.data.data.invoicingMeasures);
            }
            else if (!response.data.isSuccess) {
                setMeasuresData(null)
            }
            setShowMeasures(true);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const getConfirmationDialogMessage = (actionToPerform) => {
        const eligibleProcessMeasures = returnMeasures === null || returnMeasures.length === 0 ? measuresData : returnMeasures;
        const approvedMeasures = eligibleProcessMeasures.some(m => m.invoiceStatus === "Approved");
        if (actionToPerform === "process" && !approvedMeasures) {
            setShowNoProcessedInvoicesDialog(true);
        }
        else {
            const messages = {
                return: "You want to return the measures to the branch?",
                approve: "You want to approve?",
                process: eligibleProcessMeasures.some(m => m.invoiceStatus === "Pending")
                    ? "Only approved measures will be processed, leaving pending ones. You want to continue?"
                    : "You sure you want to process?"
            };

            setConfirmationDialogMessage(messages[actionToPerform] || "");
            setShowConfirmationDialog(true);
            setSelectedAction(actionToPerform);
        }
    }

    const handleAccept = () => {
        if (selectedAction === "return") {
            setShowReturnDialog(true);
        }
        else if (selectedAction === "approve") {
            handleApproveFinance();
        }
        if (selectedAction === "process") {
            handleShowProcessPayAppDialog();
        }
    }

    const handleHideRetrunDialog = () => {
        setSelectedReturnReason(null);
        setReturnReasonComments("");
        setReturnReasonError(false);
        setShowReturnDialog(false);
    }

    // Site search functionality
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            clientAccount: { value: null, matchMode: FilterMatchMode.CONTAINS },
            clientName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            site: { value: null, matchMode: FilterMatchMode.CONTAINS },
            contractType: { value: null, matchMode: FilterMatchMode.CONTAINS },
            siteRefNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            depotName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            totalRevenue: { value: null, matchMode: FilterMatchMode.CONTAINS },
            pendingMeasuresCount: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measuresCount: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue("");
    }

    const clearFilter = () => {
        initFilters();
    };

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="flex justify-content-end txt-right">
                        <Button className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = renderHeader();
    // Search site functionality Ends here

    const onRowSelect = (e) => {
        setSelectedSite(e.data);
        getMeasuresData(e.data.systemId);
    }

    const handleReturnMeasureSelection = (e) => {
        setReturnMeasures(e.value);
        if (e.value.length > 0) {
            setDisabaleReturnToBranchButton(false);
        }
        else {
            setDisabaleReturnToBranchButton(true);
        }
    }

    const handleApproveFinance = () => {
        setLoading(true);
        var selectedReturnMeasureIds = [];
        returnMeasures.forEach(acc => {
            const measureIds = {
                measureId: acc.measureId
            }
            selectedReturnMeasureIds.push(measureIds);
        })
        const endPoint = SERVICE_LOCATION + APPROVE_FINANCE;
        axios.post(endPoint, selectedReturnMeasureIds, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                getMeasuresData(selectedSite.systemId);
                getSitesData();
                setReturnMeasures(null);
                setDisabaleReturnToBranchButton(true);
                toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 5000 });
            }
            if (!response.data.isSuccess) {
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const handleRetrunAccounts = () => {
        selectedReturnReason === null ? setReturnReasonError(true) : setReturnReasonError(false);

        if (selectedReturnReason === null) {
            toast.current.show({ severity: "error", summary: "Error", detail: SELECT_RETURN_REASON, life: 2000 });
        }
        else {
            setLoading(true);
            var selectedReturnMeasureIds = [];
            returnMeasures.forEach(acc => {
                const measureIds = {
                    measureId: acc.measureId
                }
                selectedReturnMeasureIds.push(measureIds);
            })
            const updatedComments = returnMeasures !== "" ? `${selectedReturnReason.reason}: ${returnReasonComments}` : selectedReturnReason.reason;
            var request = {
                measureIds: selectedReturnMeasureIds,
                comments: updatedComments,
                invoiceStatusUpdatedBy: userName
            }
            const endPoint = SERVICE_LOCATION + RETURN_ACCOUNTS_TO_BRANCH;
            axios.post(endPoint, request, {
                headers: {
                    Authorization: `Bearer ${data.data.token}`,
                },
            }).then((response) => {
                setLoading(false);
                if (response.data.isSuccess) {
                    getMeasuresData(selectedSite.systemId);
                    setReturnMeasures(null);
                    setDisabaleReturnToBranchButton(true);
                    getSitesData();
                    handleHideRetrunDialog();
                    toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 5000 });
                }
                if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            }).catch((error) => {
                setLoading(false);
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
        }
    }

    const handleShowProcessPayAppDialog = () => {
        setShowProcessPayAppDialog(true);
    }

    const handleProcessPayApp = () => {
        setLoading(true);
        const eligibleProcessMeasures = returnMeasures === null || returnMeasures.length === 0 ? measuresData : returnMeasures;
        const approvedMeasures = eligibleProcessMeasures.filter(m => m.invoiceStatus === "Approved");
        var selectedReturnMeasureIds = [];
        approvedMeasures.forEach(acc => {
            const measureIds = {
                measureId: acc.measureId
            }
            selectedReturnMeasureIds.push(measureIds);
        })
        var requestDate = {
            measureIds: selectedReturnMeasureIds,
            taxCodes: selectedTaxCode,
            userName: userName
        }
        const endPoint = SERVICE_LOCATION + PROCESS_PAY_APP;
        axios.post(endPoint, requestDate, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                setReturnMeasures(null);
                getSitesData();
                setShowMeasures(false);
                handleHideProcessPayAppDialog();
                toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 5000 });
            }
            if (!response.data.isSuccess) {
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const handleShowAllWorkCardsForPayApp = (job) => {
        return <BootstrapButton id="view" onClick={() => viewAllWorkCardsForPayApp(job)}>View</BootstrapButton>
    }

    const viewAllWorkCardsForPayApp = (job) => {
        setLoading(true);
        const requestedData = {
            systemId: job.systemId
        }
        const endPoint = SERVICE_LOCATION + DOWNLOAD_PENDING_INVOICE_WORKCARD_DETAILS_BY_SYSTEMID;
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                if (response.data.data.downloadedWorkCards.length > 0) {
                    (response.data.data.downloadedWorkCards).forEach(workcard => {
                        const base64 = workcard.chunks.join("");
                        const byteCharacters = atob(base64);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: "application/pdf" });
                        const url = URL.createObjectURL(blob);
                        setPdfUrl(url);
                        setDialogHeader(`${job.clientAccount} - ${job.site}`);
                        setShowPdfViewer(true);
                    });
                }
            }
            else if (!response.data.isSuccess) {
                setPdfUrl("");
                setShowPdfViewer(false);
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
        })
    }

    const handleBackToAccounts = () => {
        setReturnMeasures(null);
        setMeasuresData(null);
        setShowMeasures(false);
        setDisabaleReturnToBranchButton(true);
    }

    const handleShowWorkCard = (job) => {
        return <BootstrapButton id="view" onClick={() => viewWorkCard(job)}>View</BootstrapButton>
    }

    const viewWorkCard = (job) => {
        setLoading(true);
        var selectedDownloadMeasureIds = [];
        const measureIds = {
            measureId: job.measureId
        }
        selectedDownloadMeasureIds.push(measureIds);
        const endPoint = SERVICE_LOCATION + DOWNLOAD_WORKCARD_DETAILS_BY_MEASUREIDs;
        axios.post(endPoint, selectedDownloadMeasureIds, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                if (response.data.data.downloadedWorkCards.length > 0) {
                    (response.data.data.downloadedWorkCards).forEach(workcard => {
                        const base64 = workcard.chunks.join("");
                        const byteCharacters = atob(base64);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: "application/pdf" });
                        const url = URL.createObjectURL(blob);
                        setPdfUrl(url);
                        setDialogHeader(`${job.plotNo} - ${job.plotDescription}`);
                        setShowPdfViewer(true);
                    });
                }
            }
            else if (!response.data.isSuccess) {
                setPdfUrl("");
                setShowPdfViewer(false);
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
        })
    }

    const handleHidePDFViewer = () => {
        setShowPdfViewer(false);
    }

    const viewSelectedWorkCardsForPayApp = () => {
        setLoading(true);
        var selectedDownloadMeasureIds = [];
        returnMeasures.forEach(acc => {
            const measureIds = {
                measureId: acc.measureId
            }
            selectedDownloadMeasureIds.push(measureIds);
        });
        const endPoint = SERVICE_LOCATION + DOWNLOAD_WORKCARD_DETAILS_BY_MEASUREIDs;
        axios.post(endPoint, selectedDownloadMeasureIds, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                if (response.data.data.downloadedWorkCards.length > 0) {
                    (response.data.data.downloadedWorkCards).forEach(workcard => {
                        const base64 = workcard.chunks.join("");
                        const byteCharacters = atob(base64);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: "application/pdf" });
                        const url = URL.createObjectURL(blob);
                        setPdfUrl(url);
                        setDialogHeader(`${selectedSite.clientAccount} - ${selectedSite.site}`);
                        setShowPdfViewer(true);
                    });
                }
            }
            else if (!response.data.isSuccess) {
                setPdfUrl("");
                setShowPdfViewer(false);
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
        })
    }

    // Measure search functionality
    const [measureFilters, setMeasureFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalMeasureFilterValue, setGlobalMeasureFilterValue] = useState("");

    const onGlobalMeasureFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...measureFilters };

        _filters["global"].value = value;

        setMeasureFilters(_filters);
        setGlobalMeasureFilterValue(value);
    };

    const clearMeasureFilter = () => {
        setMeasureFilters({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
        setGlobalMeasureFilterValue("");
    };

    const measuresHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 padr-20">
                    <Button className="btn-secondary" onClick={() => getConfirmationDialogMessage("return")} disabled={disabaleReturnToBranchButton}>Return to Branch</Button>
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 padr-20">
                    <Button className="btn-secondary" onClick={() => getConfirmationDialogMessage("approve")} disabled={disabaleReturnToBranchButton}>Finance Approve</Button>
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <Button className="btn-secondary" onClick={() => getConfirmationDialogMessage("process")}>Process Pay App</Button>
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <div className="flex justify-content-end txt-right">
                        <Button className="mar-r-20 " disabled={disabaleReturnToBranchButton} onClick={viewSelectedWorkCardsForPayApp}>View Selected Workcards</Button>
                        <Button className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearMeasureFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalMeasureFilterValue} onChange={onGlobalMeasureFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };
    // Measure search functionality ends here       

    // Staus severity with colors for submission status
    const getStatusSeverity = (invoiceStatus) => {
        switch (invoiceStatus) {
            case "Approved":
                return "approve";
            case "Pending":
                return "pending";
            default:
                return "nocolor";
        }
    };

    const statusBodyTemplate = (worksheet) => {
        return <span className={`status-severity ${getStatusSeverity(worksheet.invoiceStatus)}`}>{worksheet.invoiceStatus}</span>
    };
    // Staus severity with colors for submission status ends here

    const handleTaxCodeSelection = (event) => {
        setTaxRate(event.value.taxRate);
        setSelectedTaxCode(event.value);
    }

    const handleHideProcessPayAppDialog = () => {
        setShowProcessPayAppDialog(false);
        setTaxRate(0);
        setSelectedTaxCode(taxCodes[0]);
    }

    const noProcessedInvoicesDialogFooterContent = (
        <div>
            <BootstrapButton id="ok" onClick={() => setShowNoProcessedInvoicesDialog(false)}>Ok</BootstrapButton>
        </div>
    )

    const sitesTablePageChange = (event) => {
        setSiteDataPage(event.first / event.rows);
    };

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }
            <Toast ref={toast} />

            {!showMeasures &&
                <div className="worksheets-section">
                    <h4>Pending Accounts Review</h4>
                    <DataTable className="font-12" value={sitesData} datakey="systemId" paginator rows={10} first={siteDataPage * 10}
                        onPage={sitesTablePageChange} selectionMode="single" selection={selectedSite} onSelectionChange={(e) => setSelectedSite(e.value)}
                        onRowSelect={onRowSelect} metaKeySelection={false} filters={filters} filterDisplay="row" sortMode="multiple" header={header}
                        globalFilterFields={["clientAccount", "clientName", "site", "contractType", "systemId", "siteRefNo", "depot", "depotName", "totalRevenue", "measuresCount"]}
                        scrollable tableStyle={{ minWidth: "100rem" }} emptyMessage="No pending accounts available to review.">
                        <Column field="clientAccount" header="Client Account" sortable filter filterPlaceholder="Search by client account"></Column>
                        <Column field="clientName" header="Client Name" sortable filter filterPlaceholder="Search by client name"></Column>
                        <Column field="site" header="Site" sortable filter filterPlaceholder="Search by site"></Column>
                        <Column field="contractType" header="ContractType" sortable filter filterPlaceholder="Search by contract type"></Column>
                        <Column field="systemId" header="SystemId" hidden></Column>
                        <Column field="siteRefNo" header="Site RefNo" sortable filter filterPlaceholder="Search by siteRefNo"></Column>
                        <Column field="depot" header="DepotCode" hidden></Column>
                        <Column field="depotName" header="Depot" sortable filter filterPlaceholder="Search by depot name"></Column>
                        <Column field="totalRevenue" header="Total Revenue(£)" sortable filter filterPlaceholder="Search by total revenue"></Column>
                        <Column field="pendingMeasuresCount" header="Pending Measures" sortable filter filterPlaceholder="Search by pending measures"></Column>
                        <Column field="measuresCount" header="Measures" sortable filter filterPlaceholder="Search by measures count"></Column>
                        <Column header="Workcard" bodyStyle={{ textAlign: 'center' }} filter filterPlaceholder="View Workcard" body={handleShowAllWorkCardsForPayApp}></Column>
                    </DataTable>
                </div>
            }

            {showMeasures &&
                <div className="worksheets-section">
                    <div className="row padb-10 font-24">
                        <div className="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-6 padt-10 txt-bold">
                            {selectedSite.clientAccount} - {selectedSite.site}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div className="flex justify-content-end txt-right" onClick={handleBackToAccounts}>
                                <Button id="back" label="Back to Accounts" link onClick={handleBackToAccounts} />
                            </div>
                        </div>
                    </div>
                    <div className="row padt-10">
                        <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label className="notes-header">Client Account Notes</label>
                                <label className="notes-value">{selectedSite.clientAccountNotes}</label>
                            </div>
                        </div>
                        <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label className="notes-header">Site Account Notes</label>
                                <label className="notes-value">{selectedSite.siteAccountNotes}</label>
                            </div>
                        </div>
                        <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label className="notes-header">General Notes</label>
                                <label className="notes-value">{selectedSite.generalNotes}</label>
                            </div>
                        </div>
                    </div>
                    <DataTable className="font-12" value={measuresData} selection={returnMeasures} selectionMode="checkbox"
                        onSelectionChange={handleReturnMeasureSelection} dataKey="measureId" paginator rows={10} rowsPerPageOptions={[10, 20, 50]} filters={measureFilters}
                        scrollable header={measuresHeader} globalFilterFields={["site", "measureId", "worksheetNo", "plotId", "plotNo", "plotDescription",
                            "product", "quantity", "revenue", "paymentCardRequired", "paymentCardIncluded"]} tableStyle={{ minWidth: "50rem" }} emptyMessage="No pending accounts available to review.">
                        <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                        <Column field="site" header="Site" hidden></Column>
                        <Column field="worksheetNo" header="WorksheetNo" hidden></Column>
                        <Column field="plotId" header="PlotId" hidden></Column>
                        <Column field="plotNo" header="Plot" sortable></Column>
                        <Column field="plotDescription" header="Description" sortable></Column>
                        <Column field="invoiceStatus" header="Status" body={statusBodyTemplate} sortable></Column>
                        <Column field="product" header="Measure" sortable></Column>
                        <Column field="measureId" header="MeasureId" sortable></Column>
                        <Column field="quantity" header="Quantity" sortable></Column>
                        <Column field="revenue" header="Revenue(£)" sortable></Column>
                        <Column field="paymentCardRequired" header="PaymentCardRequired" sortable></Column>
                        <Column field="paymentCardIncluded" header="PaymentCardIncluded" sortable></Column>
                        <Column header="Workcard" body={handleShowWorkCard}></Column>
                    </DataTable>
                </div>
            }

            <Dialog header={dialogHeader} style={{ width: "310vw" }} visible={showPdfViewer} onHide={handleHidePDFViewer}>
                <div>
                    <div className="row">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                            <Button id="show-siteattention-measures" label="Back to Accounts" link style={{ fontSize: "12px", paddingLeft: "0px" }} onClick={handleHidePDFViewer} />
                        </div>
                    </div>

                    <div>
                        <iframe title="PDF Viewer" width="100%" height="500px" src={pdfUrl || ""} />
                    </div>
                </div>
            </Dialog>

            <Dialog header="Process Pay App" style={{ width: "50vw" }} visible={showProcessPayAppDialog} onHide={handleHideProcessPayAppDialog}>
                <div>
                    <div className="row">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label htmlFor="taxCode">Tax Code</label>
                                <Dropdown value={selectedTaxCode} onChange={handleTaxCodeSelection} options={taxCodes} optionLabel="taxCode"
                                    placeholder="Select Tax Code" className="w-full md:w-14rem" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label htmlFor="taxCode">Tax Rate %</label>
                                <InputText disabled value={taxRate} id="taxRate" className="p-inputtext-sm" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="flex justify-content-end txt-right">
                                <Button label="Cancel" icon="pi pi-times" onClick={handleHideProcessPayAppDialog} className="p-button-text" />
                                <Button label="Process Pay App" icon="pi pi-check" onClick={handleProcessPayApp} autoFocus />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog header="Return To Branch" style={{ width: "50vw" }} visible={showReturnDialog} onHide={handleHideRetrunDialog}>
                <div>
                    <div className="row">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label htmlFor="returnReason" className="txt-bold">Return Reason<span style={{ color: 'red' }}>*</span></label>
                                <Dropdown value={selectedReturnReason} onChange={e => setSelectedReturnReason(e.value)} options={INVOICE_RETURN_REASONS} optionLabel="reason"
                                    placeholder="Select Return Reason" className="w-full md:w-14rem" />
                                {returnReasonError && <small className="p-error">{SELECT_RETURN_REASON}</small>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label htmlFor="return-reason-comments" className="txt-bold">Comments</label>
                                <InputText value={returnReasonComments} id="return-reason-comments" className="p-inputtext-sm" onChange={(e) => setReturnReasonComments(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="flex justify-content-end txt-right">
                                <Button label="Cancel" icon="pi pi-times" onClick={handleHideRetrunDialog} className="p-button-text" />
                                <Button label="Return To Branch" icon="pi pi-check" onClick={handleRetrunAccounts} autoFocus />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <ConfirmDialog visible={showConfirmationDialog} message={confirmationDialogMessage} onHide={() => setShowConfirmationDialog(false)}
                header="Are you sure?" accept={handleAccept} />

            <Dialog header="Cannot Proceed" visible={showNoProcessedInvoicesDialog} footer={noProcessedInvoicesDialogFooterContent} onHide={() => setShowNoProcessedInvoicesDialog(false)}>
                <p className="m-0">No approved invoices available to process</p>
            </Dialog>
        </div>
    )
}

export default PendingInvoices;